import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import API from '../api';
import toast from 'react-hot-toast';
import { Eye, EyeOff } from 'lucide-react'; // eye_v1

export default function Login() {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false); // eye_v1
  const [brand, setBrand] = useState({ custom: false, name: '' }); // site_context_v1: white-label branding
  const navigate = useNavigate();

  // site_context_v1: โหลดแบรนด์ตามโดเมน — custom domain แสดงชื่อร้านลูกค้า
  useEffect(() => {
    API.get('/api/site/context')
      .then(({ data }) => {
        if (data && data.custom && data.name) {
          setBrand({ custom: true, name: data.name });
          document.title = data.name;
        }
      })
      .catch(() => {}); // fail-open: ถ้าโหลดไม่ได้ ใช้แบรนด์ AUTO CHATS ปกติ
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await API.post('/api/auth/login', form);
      localStorage.setItem('token', data.token);
      localStorage.setItem('tenant', JSON.stringify(data.tenant));
      // auto_clockin_v1: เริ่มนับเวลาทำงานอัตโนมัติ
      try { await API.post('/api/time/clock-in'); } catch (e) {}
      toast.success('เข้าสู่ระบบสำเร็จ');
      navigate('/');
    } catch (err) {
      // site_context_v1: ถ้าโดน domain-lock (403) แสดงข้อความจาก server ตรงๆ ไม่ลอง agent login
      if (err && err.response && err.response.status === 403) {
        toast.error(err.response.data?.error || 'ไม่สามารถเข้าสู่ระบบผ่านโดเมนนี้');
        return;
      }
      try {
        const { data } = await API.post('/api/auth/agent/login', form);
        localStorage.setItem('token', data.token);
        localStorage.setItem('tenant', JSON.stringify(data.agent));
        // auto_clockin_v1: เริ่มนับเวลาทำงานอัตโนมัติ
        try { await API.post('/api/time/clock-in'); } catch (e) {}
        toast.success('เข้าสู่ระบบสำเร็จ');
        navigate('/');
      } catch (err2) {
        if (err2 && err2.response && err2.response.status === 403) {
          toast.error(err2.response.data?.error || 'ไม่สามารถเข้าสู่ระบบผ่านโดเมนนี้');
        } else {
          toast.error('Email หรือ Password ไม่ถูกต้อง');
        }
      }
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a' }}>
      <div style={{ background: '#1e293b', padding: 40, borderRadius: 16, width: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
        <h1 style={{ color: '#38bdf8', fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
          {brand.custom ? brand.name : '💬 AUTO CHATS'}
        </h1>
        <p style={{ color: '#94a3b8', marginBottom: 32 }}>เข้าสู่ระบบ</p>
        <form onSubmit={submit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ color: '#94a3b8', fontSize: 13, display: 'block', marginBottom: 6 }}>อีเมล</label>
            <input type="text" value={form.email}
              onChange={e => setForm({...form, email: e.target.value})}
              style={{ width: '100%', padding: '10px 14px', borderRadius: 8, border: '1px solid #334155', background: '#0f172a', color: '#fff', fontSize: 14, boxSizing: 'border-box' }}
              required />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ color: '#94a3b8', fontSize: 13, display: 'block', marginBottom: 6 }}>รหัสผ่าน</label>
            {/* eye_v1: password input with toggle */}
            <div style={{ position: 'relative' }}>
              <input type={showPassword ? 'text' : 'password'} value={form.password}
                onChange={e => setForm({...form, password: e.target.value})}
                style={{ width: '100%', padding: '10px 44px 10px 14px', borderRadius: 8, border: '1px solid #334155', background: '#0f172a', color: '#fff', fontSize: 14, boxSizing: 'border-box' }}
                required />
              <button type="button" onClick={() => setShowPassword(!showPassword)}
                title={showPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'}
                style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <button type="submit" style={{ width: '100%', padding: '12px', background: '#0ea5e9', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 8 }}>
            เข้าสู่ระบบ
          </button>
        </form>
        {/* site_context_v1: ซ่อนลิงก์สมัครสมาชิกบน custom domain (พอร์ทัลของลูกค้า ไม่ควรโฆษณาสมัคร platform) */}
        {!brand.custom && (
          <p style={{ color: '#94a3b8', textAlign: 'center', marginTop: 20, fontSize: 14 }}>
            ยังไม่มีบัญชี? <Link to="/register" style={{ color: '#38bdf8' }}>สมัครสมาชิก</Link>
          </p>
        )}
        {brand.custom && (
          <p style={{ color: '#475569', textAlign: 'center', marginTop: 20, fontSize: 11 }}>
            powered by AUTO CHATS
          </p>
        )}
      </div>
    </div>
  );
}
